import { Loading } from 'components/core-v2/pages'
import { useEffect } from 'react'
import { useLogout } from 'utilities/hooks/useLogout'

export const Logout = () => {
  const [mutate] = useLogout()

  useEffect(() => {
    mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Loading />
}
